var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form',{attrs:{"inline":""}},[_c('label',{staticClass:"mr-sm-2"},[_vm._v("Ano")]),_c('b-form-select',{attrs:{"plain":true,"options":_vm.anos},model:{value:(_vm.anoSelecionado),callback:function ($$v) {_vm.anoSelecionado=$$v},expression:"anoSelecionado"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }